import { StackActions, useNavigation } from '@react-navigation/core';
import { BaseText, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import ZoneDetailsRow from 'components/park/ZoneDetailsRow';
import usePurchasesForVehicle, { Purchase } from 'hooks/usePurchasesForVehicle';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePermitStore } from 'stores/permitStore';
import { useParkingStore } from 'stores/parkingStore';
import { useVehicleStore } from 'stores/vehicleStore';
import { StyledWrapper } from 'styles/ContainerStyles';
import { ParkNavProps, RootNavProps } from 'types/navigation';
import { testIdentifiers } from 'utils/testIdentifiers';
import { useUiStore } from 'stores/uiStore';

const VehicleRemovalBlocked: React.FC = () => {
  const { vehicleData: editVehicle } = useVehicleStore((state) => state);
  const { navigate: navigateRoot, dispatch } = useNavigation<RootNavProps>();
  const { navigate: navigatePark } = useNavigation<ParkNavProps>();
  const { purchases } = usePurchasesForVehicle(
    editVehicle?.licensePlate?.plateText
  );
  const { t } = useTranslation();

  const getIconName = (type: string) => {
    if (type === 'START_STOP') {
      return 'Parking';
    }
    if (type === 'CHARGING') {
      return 'Charging';
    }
    return 'Services-Outlined';
  };

  const handlePress = (purchase: Purchase) => {
    const { id, type } = purchase;
    if (type === 'SALES_ORDER') {
      navigateRoot('salesOrderPermitEdit', { orderLineIdWithVersion: id });
      usePermitStore.getState().setSelectedPermit(id ?? '');
    }
    if (['ACCESS_TO_MEMBER_GROUP_LTP', 'ACCESS'].includes(type)) {
      navigateRoot('permit', { permitId: id });
    }
    if (type === 'FIXED_DURATION') {
      dispatch(
        StackActions.push('mainTabs', {
          screen: 'servicesScreen',
          params: {
            screen: 'prepaidEdit',
            params: { ticketId: id },
          },
        })
      );
    }
    if (type === 'CHARGING' || type === 'START_STOP') {
      useParkingStore
        .getState()
        .setSelectedOngoingSession(
          type === 'CHARGING' ? 'CHARGING' : 'PARKING'
        );
      useParkingStore.getState().setSelectedSessionIdFromMultiple(id);
      navigatePark('park');
    }
    useUiStore.getState().setSheetModal('');
  };
  return (
    <StyledWrapper ml={5} mr={5}>
      <StyledWrapper center maxWidth={300}>
        <BaseText
          color={theme.colors.gray300}
          center
          {...testIdentifiers('remove-vehicle-blocked-meta')}>
          {t('vehicle.removeVehicleBlocked', {
            vehicle: editVehicle?.licensePlate?.plateText,
          })}
        </BaseText>
      </StyledWrapper>
      {purchases.map((purchase, index) => (
        <ZoneDetailsRow
          key={purchase.id}
          title={purchase.name}
          chevronColor={theme.colors.black}
          icon={<Icon name={getIconName(purchase.type)} />}
          padding={20}
          onPress={() => handlePress(purchase)}
          testIDprefix={`vehicle-removal-blocked-item-${index}`}
        />
      ))}
    </StyledWrapper>
  );
};

export default VehicleRemovalBlocked;
